// extracted by mini-css-extract-plugin
module.exports = {"root":"_63f4c8"};